module.exports = __webpack_public_path__ + "static/media/footer-logo.21c6f027.svg";